import { LanguageMenuItem } from "./LanguageMenuItem";

export const mainMenuItems = ({
  myRequestsTitle = "myRequests",
  lockMyAssets = false,
} = {}) => [
  { title: "myProfile", arg: "/my-profile" },
  {
    title: "assetManagement",
    arg: "/asset-management",
    locked: lockMyAssets,
  },
  {
    title: myRequestsTitle,
    arg: "/my-requests",
  },
  { title: "homePage", arg: "/" },
];

export const dropDownLanguagesData = [
  { title: "English", arg: "en-GB" },
  { title: "Ελληνικά", arg: "GR" },
];

export const dropDownLanguages = dropDownLanguagesData.map((item) => ({
  title: <LanguageMenuItem title={item.title} arg={item.arg} />,
  arg: item.arg,
}));
